import { toSearchParams } from './to-search-params'
import { show, trackSearch } from '../../twd'

export default (values) => {
    if (!values) return

    let p = toSearchParams(values)
    setTimeout(() => {
        trackSearch('Overview Quick Screener', p)
    })

    show('offerings', Object.assign({
        searchParams: Object.assign(p, {persistToPreviousSearches:true}),
        _ts: Date.now(),
        from:'overview'
    }))
}


// WEBPACK FOOTER //
// ./src/overview/quick-screener/submit.js